import { React, Component, _ } from 'utils';
import Icon from './Icon'

export default class Tag extends Component {

	constructor(props)
	{
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const { onClick, data } = this.props;
		if(onClick) {
			onClick(data);
		}
	}

	render() {
		const { data } = this.props;
		var description = data.description;
		if(data.src == 'languageFilter'){
			description = _(data.active);
		}

 		return <span className="tag label" onClick={this.handleClick}>
			<span className="icon"><Icon type={data.src} /></span>
			<span className="desc">{description}</span>
			<span className="action fa fa-times"></span>
		</span>
	}
}



// WEBPACK FOOTER //
// ./src/modules/app/search/Tag.js